import React, { useContext, forwardRef, createContext } from 'react';
const AccordionItemContext = createContext(undefined);
const AccordionItem = forwardRef(function AccordionItem({ testId = 'store-accordion-item', children, prefixId = '', index = 0, ...otherProps }, ref) {
    const context = {
        index,
        prefixId,
        panel: `${prefixId && `${prefixId}-`}panel--${index}`,
        button: `${prefixId && `${prefixId}-`}button--${index}`,
    };
    return (React.createElement(AccordionItemContext.Provider, { value: context },
        React.createElement("div", Object.assign({ ref: ref, "data-accordion-item": true, "data-testid": testId }, otherProps), children)));
});
export function useAccordionItem() {
    const context = useContext(AccordionItemContext);
    if (context === undefined) {
        throw new Error('Do not use AccordionItem components outside the AccordionItem context.');
    }
    return context;
}
export default AccordionItem;
//# sourceMappingURL=AccordionItem.js.map